import * as React from 'react'
import { Avatar } from 'antd'
import './TTAvatar.less'
import { AvatarProps } from 'antd/lib/avatar'

export const TTAvatar: React.FC<AvatarProps> = (props) => {
    return <Avatar className="tt-avatar" {...props} />
}
